import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import uploadoss from '@/components/uploadoss'
import { refreshStyles } from 'less';
export default {
name: 'submitOrderSuccess',
directives: {
TransferDom
},
components: {
XHeader,
CheckIcon,
Group,
XButton,
uploadoss,
Confirm
},
data () {
return {
activeClass: 'wxPay',
orders: {},
payAfter: false,
isMonthlyKnots: false,
showAmount: false,
showBankInfo: false,
amount: 0,
isNoHeadEvent: true,
head: {
btnName: 'imgType',
ossdata: [],
fileArr: [],
},
accessoryInfo: {},
isUploaded: false,
showConfirm: false,
inform:false,//放假提示
}
},
methods: {
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
getItme(payMethod) {
this.activeClass = payMethod;  
if(payMethod == 'bankPay'){
this.showBankInfo = true
this.$nextTick(() => {
var ele = document.getElementsByClassName('bankInfo')[0]
ele.scrollIntoView()
})
}else if(payMethod == 'aliPay'){
this.showBankInfo = false




}else{
this.showBankInfo = false
}





},
reFlag () {
this.isNoHeadEvent = true
},

showossdataHead(data) {
this.ossdata = data;
},
showossurlHead(fileArr) {
this.accessoryInfo = fileArr[0]
if(this.accessoryInfo.imgUrl){
this.isUploaded = true
}
},
delImg () {
this.isUploaded = false
this.accessoryInfo = {}
},
getQueryString (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
var r = encodeURI(window.location.search).substr(1).match(reg);
if (r != null) {
return unescape(r[2]);
}
return null;
},
jsApiPay(){
this.$request.post('/pay/orderJSAPI',{
orderCode: this.$route.query.orderNumber,
code:this.$utils('code')
}).then((res)=>{

if(res.code == 0) {
this.payAfter = true

function onBridgeReady(){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', {
"appId":res.obj.appId,     //公众号名称，由商户传入
"timeStamp":res.obj.timeStamp,         //时间戳，自1970年以来的秒数
"nonceStr":res.obj.nonceStr, //随机串
"package":res.obj.package,
"signType":res.obj.signType,         //微信签名方式：
"paySign":res.obj.paySign ,//微信签名
},function(res){

if(res.err_msg == "get_brand_wcpay_request:ok" ){




this.getPayStatus()
}else{

this.payAfter = false
}
});
}
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
onBridgeReady();
}
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}

})
},
payOrder () {

















var ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {







window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx02774a0bb8cb2b6c&redirect_uri='+encodeURIComponent(location.href+'&payAfter=yes')+'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'

} else {
this.$request.post('/pay/order',{
orderCode: this.$route.query.orderNumber
}).then(data => {

if(data.code == 0){

this.payAfter = true

this.$vux.loading.hide()
let payAfterQuery = '&redirect_url='+location.host+':'+encodeURIComponent(location.href+'&payAfter=yes')
function myBrowser(){
var userAgent = navigator.userAgent; 
var isOpera = userAgent.indexOf("Opera") > -1;
if (isOpera) {
return "Opera"
}; //判断是否Opera浏览器
if (userAgent.indexOf("Firefox") > -1) {
return "FF";
} //判断是否Firefox浏览器
if (userAgent.indexOf("Chrome") > -1){
return "Chrome";
}
if (userAgent.indexOf("Safari") > -1) {
return "Safari";
} //判断是否Safari浏览器
if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
return "IE";
}; //判断是否IE浏览器
}

var mb = myBrowser();
var u = navigator.userAgent, app = navigator.appVersion;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if (isAndroid) {
window.location.href = data.obj+'&redirect_url='+encodeURIComponent(location.href+'&payAfter=yes')
} else if (isIOS) {

if ("Chrome" == mb) {
window.location.href = data.obj+'&redirect_url='+encodeURIComponent(location.href+'&payAfter=yes')
}else{
window.location.href = data.obj+payAfterQuery
}
} else{
window.location.href = data.obj+payAfterQuery
}
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
})
}

},
getPayStatus () {
this.$request.post('/pay/getStatus',{
orderCode: this.$route.query.orderNumber
}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/paySuccess',
query: {
orderId: this.$route.query.orderNumber
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: '尚未完成支付'
})
}
}).catch(e => {
console.log(e)
})
},
wxPay () {  //微信支付
this.$vux.loading.show({
text: ''
})
this.payOrder()
},
aliPay(){ //支付宝
console.log(this.$baseURL);
window.location.href = this.$baseURL +'alipay/gotopay?orderCode='+this.$route.query.orderNumber;
},
bankPay () {//银行转账
if(this.accessoryInfo.imgUrl){
this.$vux.loading.show({
text: ''
})
this.$request.post('/order/transferAccountsPay',{
orderCode: this.orders.orderCode,
ossTransferAccountsPath: this.accessoryInfo.imgUrl
}).then(data => {
if(data.code == 0){
this.$vux.loading.hide()
this.showConfirm = true






}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
})
}else{
this.$vux.toast.show({
type: 'warn',
text: '请先上传附件'
})
}
},
onConfirm () {
this.$router.push({
path: '/myOrder',
query: {
orderStatus: '9999'
}
})
},
monthlyPay () { //月结支付
this.$vux.loading.show({
text: ''
})
this.$request.post('/monthlyKonts/monthlyKnotsPay',{
id: this.orders.id
}).then(data => {
if(data.code == 0){
this.$vux.loading.hide()
this.$router.push({
path: '/paySuccess',
query: {
orderId: this.$route.query.orderNumber
}
})
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
})
},

getAmount () {
this.$request.post('/monthlyKonts/getAmount',{

}).then(data => {
if(data.code == 0){
this.amount = data.obj.surplusQuota
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},

getGoods () {
this.$request.post('/order/pay',{
token: this.getCookie('_token'),
orderCode: this.$route.query.orderNumber
}).then(data => {
console.log(data)
if(data.code == 0){
this.orders = data.obj
if(data.obj.ossTransferAccountsPath){
this.isUploaded = true
this.accessoryInfo.imgUrl = data.obj.ossTransferAccountsPath
}
}
}).catch(e => {
console.log(e)
})
},
payAgain () {   //再次支付
this.payOrder()
}
},
created () {
this.getGoods()



let mydate = new Date();
let year = mydate.getFullYear(); 
let mon = ((mydate.getMonth() + 1) > 9 ? (mydate.getMonth() + 1) : '0'+ (mydate.getMonth() + 1))
let day = (mydate.getDate() > 9 ? mydate.getDate() : '0'+ mydate.getDate())
let date = year + '-' + mon + '-' + day

let now = new Date(date.replace("-", "/"));
let end = new Date('2020-02-01'.replace("-", "/"));

if(end>now) {
this.inform = true;
}
if(this.$utils('code')){
this.jsApiPay()
}

},
mounted() {
console.log(location.href+'&payAfter=yes')
console.log(window.location)
if(this.$route.query.payAfter == 'yes'){
this.payAfter = true
}else{
this.payAfter = false
}
if(this.$common.getCookie('_isMonthlyKnots') == 'Y'){
this.isMonthlyKnots = true

}

},
}



// WEBPACK FOOTER //
// ./src/views/submitOrderSuccess/script.js